export type ScimAuditLogAction =
	| 'provisioned'
	| 'updated'
	| 'deactivated'
	| 'reactivated'
	| 'provision_failed'
	| 'update_failed'
	| 'deactivation_failed';

export type ScimAuditLogJSON = {
	id: number;
	action: ScimAuditLogAction;
	user_email: string | null;
	scim_external_id: string | null;
	details: Record<string, unknown> | null;
	error_message: string | null;
	created_at: string;
}

export default class ScimAuditLog {
	id: number;
	action: ScimAuditLogAction;
	userEmail: string | null;
	scimExternalId: string | null;
	details: Record<string, unknown> | null;
	errorMessage: string | null;
	createdAt: string;

	constructor(
		id: number,
		action: ScimAuditLogAction,
		userEmail: string | null,
		scimExternalId: string | null,
		details: Record<string, unknown> | null,
		errorMessage: string | null,
		createdAt: string
	) {
		this.id = id;
		this.action = action;
		this.userEmail = userEmail;
		this.scimExternalId = scimExternalId;
		this.details = details;
		this.errorMessage = errorMessage;
		this.createdAt = createdAt;
	}

	static fromJSON( json: ScimAuditLogJSON ): ScimAuditLog {
		return new ScimAuditLog(
			json.id,
			json.action,
			json.user_email,
			json.scim_external_id,
			json.details,
			json.error_message,
			json.created_at
		);
	}

	static allFromJSON( jsons: ScimAuditLogJSON[] ): ScimAuditLog[] {
		return jsons.map( ScimAuditLog.fromJSON );
	}
}
